<!-- Toolbar -->
@if (hideBanner === false) {
    <div class="banner" role="banner">
        <app-banner-settings-menu [userConnected]="userConnected"></app-banner-settings-menu>
        <span class="title">Hub4B</span>
        @if (!!userConnected) {
            <div style="width: auto; flex-grow: 1; display: flex; justify-content: center">
                <span style="font-size: 28px; /* padding-left: 650px; */ /* padding-right: 650px; */ /* width: max-content; */ /* margin: auto; */">{{ selectedTabLabel }}</span>
            </div>
        } @else {
            <div class="spacer"></div>
        }

        <button mat-icon-button class="theme-button" (click)="onThemeChange()">
            @if (!isDarkMode) {
                <mat-icon>dark_mode</mat-icon>
            }

            @if (isDarkMode) {
                <mat-icon>light_mode</mat-icon>
            }
        </button>
        @if (!!userConnected) {
            <div class="profile-container">
                <app-user-profile [userConnected]="userConnected"></app-user-profile>
            </div>
            <a class="banner-icon" (click)="openTchat()" matTooltip="T'chat" matTooltipPosition="below" [matBadge]="tchatNotification" [matBadgeHidden]="tchatNotification === 0">
                <fa-icon [icon]="tchatIcon"></fa-icon>
            </a>
            <app-banner-menu [userConnected]="userConnected"></app-banner-menu>
            <a class="banner-icon" [routerLink]="" (click)="logoff()" matTooltip="Se déconnecter" matTooltipPosition="below">
                <fa-icon [icon]="powerOffIcon"></fa-icon>
            </a>
        }
    </div>
}

<div class="main-container" style="position: relative">
    <router-outlet></router-outlet>
    <ngx-spinner name="main-spinner" [fullScreen]="true" type="timer" size="medium"></ngx-spinner>
</div>
